import {useState, useRef, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';

import useAuth from '../../hooks/useAuth';

const EditProduct = () => {
  const { auth } = useAuth();

  const navigate = useNavigate();
  const {id} = useParams();

  const [productInfo, setProductInfo] = useState({})


  const fileInputRef = useRef();
  const [productImg, setProductImg] = useState(null)
  const [mykey, setMyKey] = useState('')


  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image")
      }else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result)
        }
      }
      fileReader.onerror = error => {
          reject(error)
      }
    })
  }


  const addImage = async (e) => {
    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    fileInputRef.current.value = base64Img;
    setProductImg(e.target.files[0]);
  };

  const getData = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/products/find-product/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            })
          
            setProductInfo(res.data);

        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
      }
    

    useEffect(() => {
      getData();
    },[id])

    // ** States
   let initialState = productInfo;


    const handleChange = (event) => {
        const { value, name } = event.target
        setProductInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

    const handleUpdateClick = async (event, id) => {
        event.preventDefault();

        let productTitle = productInfo.productTitle;

        const formData = new FormData();
        formData.append('productTitle', productTitle);
        formData.append('productImg', productImg);


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/products/update-product/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/our-experience/view')


        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/our-experience/view')
    }
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Edit Product</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Product Title <span className='text-danger'>*</span>
              </Label>
              <Input
                id='title'
                type='text'
                className='me-1'
                name='productTitle'
                minLength={20}
                maxLength={90}
                required={true}
                value={productInfo.productTitle}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Image <span className='text-danger'>(max size: 100KB, width: 600 x height 597)</span>
              </Label>
              <Input
                id='productImg'
                type='file'
                className='me-1'
                name='productImg'
                accept='image/png, image/jpeg, image/jpg'
                required={true}
                key={mykey || ''}
                ref={fileInputRef} onChange={addImage}
              />
            </div>
           
            {productImg  ?  <div className='mb-3 mt-3'>
             
              <div>
              <img
                 style={{width: 180}}
                 src={fileInputRef.current.value || ''} />
              </div>
            </div> : <div className='mb-3 mt-3'>
              <div>   
              {
                productInfo.productImg &&  <img style={{width: 250}} src={`${process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api"))
               + productInfo.productImg.substring(productInfo.productImg.indexOf("/uploads"))}`} alt="product-img"></img>
              }            
             
              </div>
           </div>}

            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={event => handleUpdateClick(event, id)}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={event => handleReset(event)}
                  >
                    Cancel & Go to List
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    </div>
  );
};

export default EditProduct;
